module.exports = __webpack_public_path__ + "img/finland.2979d30d.svg";